import type * as React from 'react';
import { post } from '@Domain/Api';
import organizationWorkflowDeactivated, {
	type OrganizationWorkflowDeactivatedAction,
} from '@Application/Organizations/Workflows/Actions/organizationWorkflowDeactivated';
import organizationWorkflowDeactivationFailed, {
	type OrganizationWorkflowDeactivationFailedAction,
} from '@Application/Organizations/Workflows/Actions/organizationWorkflowDeactivationFailed';
import type DeactivateOrganizationWorkflow from '@Application/Organizations/Workflows/Commands/DeactivateOrganizationWorkflow';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = OrganizationWorkflowDeactivatedAction | OrganizationWorkflowDeactivationFailedAction;

export default (command: DeactivateOrganizationWorkflow) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await post<void>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/workflows/${command.workflowKey}/deactivations`,
				command.toJSON(),
			);

			const action = organizationWorkflowDeactivated(
				{ workflowKey: command.workflowKey },
				command.organizationId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = organizationWorkflowDeactivationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
